import * as stylex from '@stylexjs/stylex'

export const systemColor = {
  brand: '#FF9E1B',
  white: '#FFFFFF',
  black: '#000000',

  /**
   * primary, secondary, tertiary 在沒有被 ThemeProvider 覆蓋時，預設的顏色為 lime，以方便辨識
   * 個品牌定義請於範例中查看 libs/pets-ui/src/themes/dcs.ts
   * https://stylexjs.com/docs/learn/theming/creating-themes/
  */
  primary50: 'lime',
  primary100: 'lime',
  primary200: 'lime',
  primary300: 'lime',
  primary400: 'lime',
  primary500: 'lime',
  primary600: 'lime',
  primary700: 'lime',
  primary800: 'lime',
  primary900: 'lime',

  secondary50: 'lime',
  secondary100: 'lime',
  secondary200: 'lime',
  secondary300: 'lime',
  secondary400: 'lime',
  secondary500: 'lime',
  secondary600: 'lime',
  secondary700: 'lime',
  secondary800: 'lime',
  secondary900: 'lime',

  tertiary50: 'lime',
  tertiary100: 'lime',
  tertiary200: 'lime',
  tertiary300: 'lime',
  tertiary400: 'lime',
  tertiary500: 'lime',
  tertiary600: 'lime',
  tertiary700: 'lime',
  tertiary800: 'lime',
  tertiary900: 'lime',

  grey50: '#FAFAFA',
  grey100: '#F5F5F5',
  grey200: '#EEEEEE',
  grey300: '#E1E1E1',
  grey400: '#BEBEBE',
  grey500: '#9E9E9E',
  grey600: '#757575',
  grey700: '#616161',
  grey800: '#424242',
  grey900: '#212121',

  green50: '#F2FAF5',
  green100: '#DAFAE1',
  green200: '#B1EDBF',
  green300: '#8ED6A1',
  green400: '#6AC485',
  green500: '#27B556',
  green600: '#00A33C',
  green700: '#008230',
  green800: '#006B28',

  red50: '#FFF5F5',
  red100: '#FEEFEF',
  red300: '#FFB5B5',
  red400: '#FF968F',
  red500: '#FF7671',
  red600: '#FF5353',
  red700: '#D23339',
  red800: '#A61B24',

  blue50: '#F2F9FF',
  blue100: '#E3F2FD',
  blue300: '#B3E5FC',
  blue400: '#6ABFFC',
  blue600: '#178CFA',
  blue700: '#206CCF',
  blue800: '#114BA3',

  yellow50: '#FFFBEC',
  yellow100: '#FFF8DB',
  yellow200: '#FFF9BA',
  yellow300: '#FFF18B',
  yellow400: '#FFE600',
  yellow500: '#FFDC48',
  yellow600: '#FFC700',
  yellow700: '#D29E00',

  blueGrey50: '#F7FAFC',
  blueGrey100: '#EDF2F7',
  blueGrey200: '#E2E8F0',
  blueGrey300: '#CBD5E0',
  blueGrey400: '#B0BEC5',
  blueGrey500: '#90A4AE',
  blueGrey600: '#78909C',
  blueGrey700: '#607D8B',
  blueGrey800: '#546E7A',
  blueGrey900: '#455A64',

  orange100: '#fef2f0',
  orange500: '#f68066',
  orange600: '#ca7658',

  violet100: '#F6E8FF',
  violet600: '#9747FF',
}

export const colors = stylex.defineVars(systemColor)
export type Colors = typeof colors
